import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import MainView from '../components/MainView/MainView'

import {
  setNewOffers,
  setOffers,
  setRewards,
  setOfferModalData,
  setOfferModalStatus,
  setRewardModalData,
  setRewardModalStatus,
  setRewardsCatalog,
} from '../../../modules/offers/actions/creators'

import { setMerchants } from '../../../modules/dashboard/actions/creators'

import {
  setPrimaryInfo,
  setAccountStatus,
  displayProfileModal,
  setTransportationMall,
  setProfileModalPage,
  setProfileModalDetailPage,
  setFavoriteMalls,
} from '../../../modules/profile/actions/creators'

import { setSelectedMallSlug } from '../../../modules/explore/actions/creators'

import {
  setAccessToken,
  setFirebaseMessagingToken,
} from '../../../modules/auth/actions/creators'

import {
  setLoyaltyPoints,
  setTransactionsEarned,
  setTransactionsRedeemed,
} from '../../../modules/loyalty/actions/creators'

import {
  waitRenderServer,
  renderServer,
} from '../../../modules/ssr/actions/creators'

import { setError, removeError } from '../../../modules/errors/actions/creators'

import { withFirebase } from '../../../components/accessibility/Firebase/Firebase'

import {
  doGetAllMalls,
  doGetAllBrands,
  doGetShopCategories,
  doChangeCategories,
} from '../../../controllers/ZingShops'

const mapStateToProps = reduxState => {
  const {
    dashboard,
    auth,
    profile,
    offers: offerPageData,
    loyalty,
    errors,
    explore,
  } = reduxState
  const { accessToken, firebaseMessagingToken } = auth
  const {
    primaryInfo,
    advanceAccount,
    registrationToken,
    favoriteMalls,
  } = profile
  const { malls, merchants, deviceLocation } = dashboard
  const {
    newOffers,
    offers,
    rewards,
    rewardsCatalog,
    showOfferModal,
    offerModalData,
    offerModalStatus,
    showRewardModal,
    rewardModalData,
    rewardModalStatus,
  } = offerPageData
  const { loyaltyPoints, transactionsEarned, transactionsRedeemed } = loyalty
  const { errorList } = errors
  const { selectedMallSlug, merchantModalData, merchantModalStatus } = explore

  return {
    primaryInfo,
    advanceAccount,
    registrationToken,
    accessToken,
    malls,
    newOffers,
    offers,
    rewards,
    merchants,
    rewardsCatalog,
    showOfferModal,
    offerModalData,
    offerModalStatus,
    showRewardModal,
    rewardModalData,
    rewardModalStatus,
    loyaltyPoints,
    transactionsEarned,
    transactionsRedeemed,
    errorList,
    selectedMallSlug,
    merchantModalData,
    merchantModalStatus,
    deviceLocation,
    favoriteMalls,
    firebaseMessagingToken,
    doGetAllMalls,
    doGetAllBrands,
    doGetShopCategories,
    doChangeCategories,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setPrimaryInfo,
      setAccessToken,
      setAccountStatus,
      setLoyaltyPoints,
      setTransactionsEarned,
      setTransactionsRedeemed,
      setNewOffers,
      setOffers,
      setRewards,
      setRewardsCatalog,
      setOfferModalData,
      setOfferModalStatus,
      setRewardModalData,
      setRewardModalStatus,
      displayProfileModal,
      setTransportationMall,
      setProfileModalPage,
      setProfileModalDetailPage,
      setError,
      removeError,
      push,
      waitRenderServer,
      renderServer,
      setMerchants,
      setSelectedMallSlug,
      setFavoriteMalls,
      setFirebaseMessagingToken,
    },
    dispatch,
  )

const ConnectedMainView = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withFirebase(MainView))

export default ConnectedMainView
